import { User as m, Share2 as p, Money as h, Settings as b, HelpCircle as f, MessageCircle as u, Sliders as d, Heart as y, LogIn as x, LogOut as g, Grid as v, Shop as j, ShoppingBag as I, Briefcase as w, Bell as D, Shield as O, Wallet as _, ConfiguracaoDeServico as S } from "@olxbr/ds-icons";
import "../../Lurker/Lurker.js";
import { getABTest as C } from "../../../helpers/ab.js";
import { addItemToSubmenu as P } from "./addItemToSubmenu.js";
var M = Object.defineProperty,
  A = Object.defineProperties,
  E = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  F = Object.prototype.hasOwnProperty,
  B = Object.prototype.propertyIsEnumerable,
  n = (e, o, a) => o in e ? M(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[o] = a,
  L = (e, o) => {
    for (var a in o || (o = {})) F.call(o, a) && n(e, a, o[a]);
    if (l) for (var a of l(o)) B.call(o, a) && n(e, a, o[a]);
    return e;
  },
  k = (e, o) => A(e, E(o));
const G = () => C("autospp-marketplace-header_enabled"),
  r = e => k(L({}, e), {
    divider: !0
  }),
  t = {
    chat: {
      title: "Chat",
      href: "https://conta.olx.com.br/chats",
      Icon: u,
      objectDetail: "chat"
    },
    communicationConfig: {
      title: "Configura\xE7\xF5es de comunica\xE7\xF5es",
      href: "https://conta.olx.com.br/comunicacoes",
      Icon: d,
      objectDetail: "communication"
    },
    favorites: {
      title: "Favoritos",
      href: "https://www3.olx.com.br/account/favorites",
      Icon: y,
      objectDetail: "favorite_ads"
    },
    login: {
      title: "Entrar",
      href: "https://conta.olx.com.br/anuncios",
      Icon: x,
      objectDetail: "login"
    },
    logout: {
      title: "Sair",
      href: "https://www3.olx.com.br/account/do_logout",
      Icon: g,
      objectDetail: "logout"
    },
    myAds: {
      title: "Meus an\xFAncios",
      href: "https://conta.olx.com.br/anuncios",
      Icon: v,
      objectDetail: "my_ads"
    },
    mySales: {
      title: "Minhas vendas",
      href: "https://meus-pedidos.olx.com.br/minhas-vendas",
      Icon: j,
      objectDetail: "olx_pay_seller_orders"
    },
    myOrders: {
      title: "Minhas compras",
      href: "https://meus-pedidos.olx.com.br/minhas-compras",
      Icon: I,
      objectDetail: "olx_pay_buyer_orders"
    },
    myPlan: {
      title: "Plano profissional",
      href: "https://planoprofissional.olx.com.br/",
      Icon: w,
      objectDetail: "my_plan"
    },
    notifications: {
      title: "Notifica\xE7\xF5es",
      href: "https://conta.olx.com.br/notificacoes/",
      Icon: D,
      objectDetail: "notification"
    },
    securityCentral: {
      title: "Seguran\xE7a e privacidade",
      href: "https://conta.olx.com.br/seguranca",
      Icon: O,
      objectDetail: "security_central"
    },
    wallet: {
      title: "Carteira OLX",
      href: "https://wallet.olx.com.br/",
      Icon: _,
      objectDetail: "wallet"
    }
  };
var H = _ref => {
  let {
    publicAccountId: e,
    menuPro: o = !1
  } = _ref;
  const a = [t.login, r(t.chat), t.myAds, t.mySales, r(t.myPlan), t.myOrders],
    i = [{
      title: "Meu cadastro",
      href: "https://www3.olx.com.br/account/form_userinfo",
      Icon: m,
      divider: !0,
      objectDetail: "conta"
    }, t.notifications, r(t.chat), t.myAds, t.mySales, t.wallet, t.myPlan, {
      title: "Meu perfil p\xFAblico",
      divider: !0,
      href: "https://www.olx.com.br/perfil/".concat(e),
      Icon: p,
      objectDetail: "profile_page"
    }, t.myOrders, r(t.favorites), t.securityCentral, t.communicationConfig, {
      title: "Gerenciar Pagamentos",
      href: "https://conta.olx.com.br/pagamentos",
      Icon: h,
      divider: !0,
      objectDetail: "payment_central"
    }, t.logout],
    s = [{
      title: "Minha conta",
      href: "https://conta.olx.com.br/meu-cadastro",
      Icon: b,
      objectDetail: "conta"
    }, t.notifications, r(t.favorites), t.myOrders, t.mySales, r(t.wallet), t.securityCentral, r(t.communicationConfig), {
      title: "Ajuda",
      href: "https://ajuda.olx.com.br/s",
      Icon: f,
      divider: !0,
      objectDetail: "help",
      badge: "novo"
    }, t.logout],
    c = {
      title: "Servi\xE7os Automotivos OLX",
      href: "https://autos-marketplace.olx.com.br/",
      Icon: S,
      objectDetail: "autos_marketplace",
      positionOnMenu: 7
    };
  return e && o ? s : (G() && P(i, c, c.positionOnMenu), e ? i : a);
};
export { H as default };